import React from 'react';

import * as dataCollectionTypes from '../../../../consts/uam/dataCollectionTypes';
import DataCollectionBaseHandler from './DataCollectionBaseHandler';

const DataCollectionHandler = () => {
    return <DataCollectionBaseHandler dataCollectionType={dataCollectionTypes.DATA_COLLECTION_GLOBAL} />;
};

export default DataCollectionHandler;
